/** `/c/$companyId/settings/periods` — fiscal years, periods and lock exceptions; anyone with access reads them. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PeriodsScreen } from "../ledger/PeriodsScreen";

export const Route = createFileRoute("/_auth/c/$companyId/settings/periods")({
  component: PeriodsRoute,
});

function PeriodsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <PeriodsScreen companyId={companyId} />;
}
